export enum TextGeneratorTone {
    Celebratory,
    Neutral,
    Serious,
    Warning
}

export enum TextGeneratorLength {
    Short,
    Medium,
    Long
}